import { mount } from 'svelte';
import './app.css';
import App from './App.svelte';
import * as Sentry from "@sentry/svelte";
import posthog from 'posthog-js';

Sentry.init({
    dsn: "https://e8427145d8912584d36a6b3f092f6273@o4508631719804928.ingest.us.sentry.io/4508631723278336",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
        Sentry.feedbackIntegration({
            colorScheme: "system",
            autoInject: false,
            formTitle: 'Feedback',
            submitButtonLabel: 'Submit Feedback',
            messagePlaceholder: 'How can we improve this app? Did you find a bug?',

        })
    ],
    // @ts-ignore
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: '2026-05-30',
});

const app = mount(App, {
    target: document.getElementById('app')!,
});


export default app;
